import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { toggleDialog } from '../../../../store/control/duck';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { SlideTransition } from '../../../../components/Transition/Transition';
import Typography from '@mui/material/Typography';

const ExportOptionsHintDialog = props => {
  const { intl, analysisExportOptionsHintDialog, toggleDialog } = props;

  const { closed } = analysisExportOptionsHintDialog || {};

  const close = () => toggleDialog('analysisExportOptionsHint', { ...analysisExportOptionsHintDialog, closed: true });
  const onClosed = () => toggleDialog('analysisExportOptionsHint', false);

  return (
    <Dialog
      open={!!analysisExportOptionsHintDialog && !closed}
      onClose={close}
      fullWidth={true}
      slots={{
        transition: SlideTransition
      }}
      slotProps={{
        transition: {
          onExited: onClosed
        }
      }}>
      <DialogTitle>{intl.formatMessage({ id: 'export-options-hint-dialog-title' })}</DialogTitle>
      <DialogContent>
        <Typography>{intl.formatMessage({ id: 'export-options-hint-dialog-content' })}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={close}>
          {intl.formatMessage({ id: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const container = connect(
  state => ({
    analysisExportOptionsHintDialog: state.control.analysisExportOptionsHintDialog
  }),
  {
    toggleDialog
  }
)(ExportOptionsHintDialog);

export default injectIntl(container);
